import React from "react";
import { Link } from "react-router-dom";

import "./SleepBlog.css";

export default function SleepBlog() {
  return (
    <div className="sleep-wrapper">
      {/* Hero Section */}
      <section className="sleep-hero">
        <div className="hero-content">
          <h1>Micro-Habits for Better Sleep</h1>
          <p>Small evening routines for calmer nights.</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="sleep-container">
        <h2>Explore Better Sleep — One Small Step at a Time</h2>
        <p className="intro-text">
          Learn how tiny adjustments before bedtime can improve sleep quality 
          without stress. These habits are simple, effective, and take less 
          than 5 minutes to apply.
        </p>

        {/* Content Sections */}
        <section className="sleep-section">
          <h3>🕯️ Dim the Lights 30 Minutes Before Bed</h3>
          <p>
            Reducing light exposure helps your brain produce melatonin — the sleep hormone.
            Try switching to warm light or using a lamp instead of overhead lighting.
          </p>
        </section>

        <section className="sleep-section">
          <h3>📵 5-Minute Digital Wind-Down</h3>
          <p>
            Put your phone away or switch to airplane mode. Create distance from notifications to 
            tell your brain that the day is over.
          </p>
        </section>

        <section className="sleep-section">
          <h3>📝 Release the Mind — Quick Journal</h3>
          <p>
            Write down tasks, worries or to-do items. It signals closure to your mind and reduces 
            nighttime overthinking.
          </p>
        </section>

        <section className="sleep-section">
          <h3>💧 Warm Water Routine</h3>
          <p>
            Drink a small glass of warm herbal tea or water. The warmth helps your body relax 
            and signals that it’s time to rest.
          </p>
        </section>

        <section className="sleep-section">
          <h3>🌬️ 4-7-8 Breathing</h3>
          <p>
            Inhale for 4 seconds, hold for 7, exhale for 8.  
            This activates your parasympathetic nervous system — the calm state.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer className="sleep-footer">
        <p>© 2025 CalmNote Wellness. Sleep Better, Live Better.</p>
          <Link to={'/privacyPolicy'}>
                    Pivacy Policy
                </Link>
      </footer>
    </div>
  );
}


